import * as Y from 'yjs';

export type YJSInput =
    | Y.Map<unknown>
    | Y.Array<unknown>
    | Y.Text
    | Y.XmlText
    | Y.XmlFragment
    | Y.XmlElement;

/**
 * Test if a value is a Yjs value.
 */
export function isYValue(value: any): value is YJSInput {
    return (
        value instanceof Y.Map ||
        value instanceof Y.Array ||
        value instanceof Y.Text ||
        value instanceof Y.XmlElement ||
        value instanceof Y.XmlText ||
        value instanceof Y.XmlHook ||
        value instanceof Y.XmlFragment
    );
}
